export default __webpack_public_path__ + "static/cover-101eb28af37ea15abd787dbaa3ed0034.jpg";